<template>
  <label class="select-wrapper">
      <span v-if="label">
        {{ $t(label) }}
      </span>
    <select class="custom-select" v-model="value" v-bind="$attrs">
      <option v-if="withEmpty" :value="null"/>
      <option v-for="(item) in data"
              :key="item[propForValue]"
              :value="item[propForValue]"
      >
        <slot
            :item="item"
        >
          {{ item[propForDisplay] }}
        </slot>
      </option>
    </select>
  </label>
</template>

<script>
export default {
  name: 'SelectComponent',
  props: {
    data: {
      type: Array,
      required: true,
    },
    selectedValue: {
      type: [String, Number],
      default: null,
    },
    propForDisplay: {
      type: String,
      default: 'name',
    },
    propForValue: {
      type: String,
      default: 'id',
    },
    label: {
      type: String,
    },
    withEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.selectedValue || this.data.find(({selected}) => selected)?.[this.propForValue],
    };
  },
  watch: {
    value(newValue) {
      this.$emit('update:selectedValue', newValue);
    },
    selectedValue(newValue) {
      this.value = newValue;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/css/colors";

.select-wrapper {
  display: flex;
  border-radius: .3rem;
  border: 1px solid $text-tertiary-middle;
  align-items: center;
  justify-content: center;

  span {
    padding: .5rem 1rem;
    border-bottom-left-radius: .3rem;
    border-top-left-radius: .3rem;
    background: $text-tertiary-light;
  }

  select {
    min-width: 10rem;
    border: none;
    option {
      display: contents;
    }
  }
}
</style>
